<template>
    <el-popover
        placement="bottom"
        width="200"
        @show="showPopover"
        @hide="hidePopover"
        trigger="click">
        <el-button slot="reference" size="mini" type="primary" class="ml20" plain>+添加筛选</el-button>
        <div class="popover-wrap">
            <ul>
                <li class="mt4 mb4" v-if="options.length>0">
                    <el-checkbox v-model="isSelectAll" :indeterminate="isIndeterminate" @change="selectAll">全选</el-checkbox>
                </li>
                <li class="mt4 mb4 ml10" v-for="(item,index) in options" :key="item.name+''+index">
                    <el-checkbox v-model="item.checked" :disabled="item.default_check=='1'" @change="itemCheckChange">
                        {{item.display_name}}
                    </el-checkbox>
                </li>
            </ul>
        </div>
    </el-popover>
</template>

<script>
    export default {
        name: "FilterPopSelect",
        props:{
            list:Array,
            value:Array,
        },
        data(){
            return {
                options:[],
                isSelectAll:false,

            }
        },
        computed:{
            isIndeterminate(){
                let options = this.options||[];
                return options.some(item=>item.checked)&&options.some(item=>!item.checked);
            },
        },
        methods:{
            showPopover(){
                let listData = this.list||[];
                let checkedList = this.value||[];
                this.options = listData.map(item=>{
                    return {
                        default_check:item.default_check,
                        name:item.name,
                        display_name:item.display_name,
                        checked:checkedList.includes(item.name),
                    };
                });
                this.isSelectAll = checkedList.length>0&&(this.options.length==checkedList.length);
            },
            hidePopover(){
                console.log('hidePopover');
                let checkedList = this.options.filter(item=>item.checked).map(item=>item.name);
                this.$emit('change',checkedList);
            },
            itemCheckChange(){
                this.isSelectAll = this.options.every(item=>item.checked);
            },
            selectAll(val){
                this.options.forEach(item=>{
                    if(item.default_check!='1'){
                        item.checked = val;
                    }else{
                        item.checked = true;
                    }
                    // item.checked = val;
                })
            },
        },
    }
</script>

<style lang="scss" scoped>
    .popover-wrap{
        max-height: 300px;
        overflow-y: auto;
    }
</style>
